import { render } from "./EnUnit2-4.vue?vue&type=template&id=64c3e967&scoped=true"
import script from "./EnUnit2-4.vue?vue&type=script&lang=js"
export * from "./EnUnit2-4.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=64c3e967&scoped=true&lang=css"
import "../assets/css/en/Unit2-4.css?vue&type=style&index=1&id=64c3e967&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3e967"]])

export default __exports__